import React, { useState } from 'react'
import useEquipment from '../../hooks/useEquipment';
import useUser from '../../hooks/useUser';

//table
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LinearProgress } from '@mui/material';

//icons
import{  
  XCircleIcon,  
  EyeIcon
}from "@heroicons/react/24/outline"

import WriteLog from '../Globals/WriteLog';
import useLocation from '../../hooks/useLocation';

function Equipment({addrSeq}) {
  
    WriteLog("Equipment->addrSeq", addrSeq);
    const { user } = useUser();

    const {equipments} = useEquipment(user?.customer_code, addrSeq, user?.token)
    WriteLog("Equipment->Equipments", equipments)
    
    //location
    const { locations } = useLocation(user?.customer_code, user?.token);                
    console.log("Equipment->locations", locations);      
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
    console.log("Equipment->location", location);
      
    //service popup
    const [openService, setOpenService] = useState(false)
    const [services, setServices] = useState(null);
    const closeService = ()=>setOpenService(false)
    function showService(e, services)
      {
        setOpenService(true)
        setServices(services);        
      }

  //Table
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#DDD",
      color: theme.palette.common.black,   
      height:60       
    },
    [`&.${tableCellClasses.body}`]: {          
      border:'3px solid #FFF',           
      height:50,
      padding:5,
      margin:0  
    },
    [`&.${tableCellClasses.root}`]: {            
        border:'3px solid #FFF',            
      },        
      [`&.${tableCellClasses.hover}`]: {            
        backgroundColor: "#0F0",
      },        
  }));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,   
                 
    },       
    //hide last border
    // "&:last-child td, &:last-child th": {
    //     border: 0,
    // },
}));

return (
    <div className="flex-grow overflow-y-auto bg-white">

        <div className='flex pl-5 pt-5 items-center space-x-3'>
            <div className='text-3xl font-bold' >Equipment:</div>
            <div className='p-1 text-center text-sm rounded-full bg-orange-200 text-black'>{equipments?.equipments?.length}</div>
        </div>  
        <div className='flex ml-10 mt-2 items-baseline space-x-2'>
            <div className='text-xl text-gray-500 font-bold'>Location:</div>
            <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>
        </div>      
        <div className='pl-10 pt-1 pr-10'>
            {!equipments &&
                <LinearProgress color='primary' />
            }
        </div> 
        <div className='ml-10 mt-2 mr-10'> 

          <TableContainer component={Paper}>
              <Table>
                  <colgroup>
                      <col width="25%" />
                      <col width="15%" />
                      <col width="15%" />
                      <col width="10%" />                    
                  </colgroup>
                  <TableHead>
                      <TableRow>
                          <StyledTableCell align="left">Equipment</StyledTableCell>
                          <StyledTableCell align="left">Category</StyledTableCell>
                          <StyledTableCell align="left">Location</StyledTableCell>                            
                          <StyledTableCell align="center">Services</StyledTableCell>                        
                      </TableRow>
                  </TableHead>
                  <TableBody> 
                    {equipments?.equipments?.map((equi) => ( 
                        <StyledTableRow key={`${equi.primary_key}`}>
                          <StyledTableCell align="left"><div className="text-gray-500 text-sm">{equi.comments}</div></StyledTableCell>                            
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{equi.category_name}</div></StyledTableCell>                          
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{equi.location}</div></StyledTableCell>
                            <StyledTableCell align="center">
                              <div className="flex text-gray-500 text-sm items-center justify-center">
                                <div className='p-2 hover:bg-slate-200 rounded-full'>
                                  <EyeIcon className='w-6 h-6 hover:text-black-800 text-center cursor-pointer' onClick={(e)=>showService(e, equi.service_history)} />                                                                
                                </div>                                  
                                {/* <button onClick={(e)=>showService(e, equi.service_history)} className='form-button w-24 h-7 items-center rounded-full text-white bg-orange-700 hover:bg-orange-400'>Service</button> */}
                              </div>
                            </StyledTableCell>
                        </StyledTableRow>                  
                    ))}
                  </TableBody>
            </Table>
          </TableContainer>        
        </div>
        {openService &&
          <div className='popupContainer'>  
            <div className='w-1/4 h-96 bg-white rounded-lg shadow-2xl '>
              <div className='relative flex items-center p-3 justify-evenly border-b  bg-gray-300'>
                      <div className=' text-black font-semibold font-sans'>
                        Service History
                      </div>                    
                      <div className=' absolute text-gray-300 top-1 right-1 cursor-pointer'>
                          <XCircleIcon className='h-9 w-9 text-red-400' onClick={closeService}></XCircleIcon>                    
                      </div> 
              </div> 
              <div className='flex justify-center mx-5 overflow-auto scroll-auto h-72'>
                <div>
                  {services?.map((service) => (                       
                      <div className='flex items-center' key={`${service.service_date}`}>
                          <div className='m-3 w-24 bg-gray-200 p-1 rounded-lg text-center'>
                            WO-{service?.work_order_id}
                          </div>
                          <div>
                            {service?.service_date != "" &&
                              new Intl.DateTimeFormat("en-GB", {
                                year: "numeric",
                                month: "long",
                                day: "2-digit",                                                
                                }).format(new Date(service?.service_date))  
                            }
                          </div>                                                                  
                      </div>                        
                    ))}
                  </div>
              </div>              
              </div>
          </div>
        }

    </div>
  )
}

export default Equipment